export default __webpack_public_path__ + "static/media/m_logo.8b0aceda.svg";